import styled from "styled-components";

export const MainNavItem = styled.li`
  margin: inherit;
  cursor: pointer;

  @media ${({ theme }) => theme.mq.sm} {
    margin: 16px 0;
    text-align: center;
  }
`;
